<div class="chart-container" #chartContainer>
  <div #container class="container"></div>
  <div #minimapContainer class="min-map">
  </div>
</div>

<div
    #edgeTooltip
    class="edge-tooltip"
>
    <div *ngFor="let item of currentEdgeInfo" class="tooltip-info">
        <div class="item">
            <div class="item-label">
                sourcePort :
            </div>
            <div class="item-value">
                {{ item.sourcePort }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                targetPort :
            </div>
            <div class="item-value">
                {{ item.targetPort }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                sourceMemo :
            </div>
            <div class="item-value">
                {{ item.sourceMemo }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                targetMemo :
            </div>
            <div class="item-value">
                {{ item.targetMemo }}
            </div>
        </div>
    </div>
</div>

<div
    #nodeTooltip
    class="edge-tooltip"
>
    <div class="tooltip-info">
        <div class="item">
            <div class="item-label">
                Resource Type :
            </div>
            <div class="item-value">
                {{ currentNodeInfo?.resourceDefinitionTitle ? currentNodeInfo?.resourceDefinitionTitle : formatResourceName(currentNodeInfo?.hardwareType) }}
            </div>
        </div>
        <div class="item">
            <div class="item-label">
                Location Lab :
            </div>
            <div class="item-value">
                {{ currentNodeInfo?.locationLab?.name || '' }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                Location Room :
            </div>
            <div class="item-value">
                {{ currentNodeInfo?.locationRoom?.name || '' }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                Location Type :
            </div>
            <div class="item-value">
                {{ currentNodeInfo?.locationType?.name || '' }}
            </div>
        </div>

        <div class="item">
            <div class="item-label">
                Location :
            </div>
            <div class="item-value">
                {{ getLocation(currentNodeInfo?.location) }}
            </div>
        </div>
    </div>
</div>

